// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ag3M","postMainActionContainer":"_20Pba","wrapper":"_1vwK3","icon":"_1QzPW","postMainActionWrapper":"eglA3"};